import * as React from 'react';
import {
  FeatureArticleContainer,
  FeatureArticleIllustrationContainer,
} from '../../../../../news/components/sections/home/components/featureArticle/components';
import {
  HomeFeaturedNewsImage,
  HomeFeaturedNewsTitle,
} from './components';
import { FeatureArticleTextContainer } from '../../../../../news/components/sections/home/components/featureArticle/components/text/components';

export const HomeFeatureNewsContent = () => (
  <FeatureArticleContainer
    marginBottom="none"
  >
    <FeatureArticleIllustrationContainer>
      <HomeFeaturedNewsImage />
    </FeatureArticleIllustrationContainer>
    <FeatureArticleTextContainer>
      <HomeFeaturedNewsTitle />
    </FeatureArticleTextContainer>
  </FeatureArticleContainer>
);
